/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { CourseRegistrationDocumentStatusResponseViewModel } from "../types/CourseRegistrationDocumentStatusResponseViewModel.ts";
import { eDocumentationStatusSchema } from "./eDocumentationStatusSchema.ts";

export const courseRegistrationDocumentStatusResponseViewModelSchema = z.object(
  {
    statusDocument: z.optional(
      z
        .lazy(() => eDocumentationStatusSchema)
        .describe(
          "0 = Pending | 1 = Approved | 2 = Rejected | 3 = ApprovedTemporary | ",
        ),
    ),
    approvedBy: z
      .string()
      .describe("usuário que aprovou o documento.")
      .nullish(),
    rejectReasonName: z
      .string()
      .describe("Motivo da rejeição do documento formatado.")
      .nullish(),
  },
) as unknown as ToZod<CourseRegistrationDocumentStatusResponseViewModel>;
